import React from "react";

const ClaritalkSettings = () => {
  return (
    <>
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="50" cy="50" r="50" fill="#E55496" />
        <path
          d="M44.2286 74.9905C39.4083 74.9905 35.1162 73.8679 31.3524 71.6229C27.5886 69.3117 24.6171 66.1752 22.4381 62.2133C20.3251 58.2514 19.2686 53.7283 19.2686 48.6438C19.2686 43.5594 20.3251 39.0692 22.4381 35.1733C24.6171 31.2114 27.5886 28.1079 31.3524 25.8629C35.1162 23.6178 39.3752 22.4952 44.1295 22.4952C48.1575 22.4952 51.7562 23.2546 54.9257 24.7733C58.0952 26.2921 60.7035 28.4051 62.7505 31.1124C64.7975 33.8197 66.1181 37.0222 66.7124 40.72H57.0057C56.3454 37.7486 54.8927 35.3714 52.6476 33.5886C50.4686 31.8057 47.6952 30.9143 44.3276 30.9143C41.4222 30.9143 38.88 31.6406 36.701 33.0933C34.5219 34.546 32.8381 36.593 31.6495 39.2343C30.461 41.8756 29.8667 45.0121 29.8667 48.6438C29.8667 52.2095 30.461 55.346 31.6495 58.0533C32.8381 60.7606 34.5219 62.8736 36.701 64.3924C38.88 65.8451 41.4552 66.5714 44.4267 66.5714C47.6622 66.5714 50.4025 65.713 52.6476 63.9962C54.9587 62.2133 56.4444 59.8362 57.1048 56.8648H66.8114C66.1511 60.4965 64.7644 63.666 62.6514 66.3733C60.6044 69.0806 57.9962 71.1937 54.8267 72.7124C51.6571 74.2311 48.1244 74.9905 44.2286 74.9905Z"
          fill="white"
        />
        <path
          d="M74 55C75.023 55 76.0041 55.4325 76.7274 56.2024C77.4508 56.9723 77.8571 58.0165 77.8571 59.1053V67.3158C77.8571 68.4046 77.4508 69.4488 76.7274 70.2186C76.0041 70.9885 75.023 71.4211 74 71.4211C72.977 71.4211 71.9959 70.9885 71.2726 70.2186C70.5492 69.4488 70.1429 68.4046 70.1429 67.3158V59.1053C70.1429 58.0165 70.5492 56.9723 71.2726 56.2024C71.9959 55.4325 72.977 55 74 55ZM83 67.3158C83 72.1463 79.6443 76.1284 75.2857 76.7989V81H72.7143V76.7989C68.3557 76.1284 65 72.1463 65 67.3158H67.5714C67.5714 69.1304 68.2487 70.8707 69.4543 72.1539C70.6599 73.437 72.295 74.1579 74 74.1579C75.705 74.1579 77.3401 73.437 78.5457 72.1539C79.7513 70.8707 80.4286 69.1304 80.4286 67.3158H83Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default ClaritalkSettings;
